<template>
  <div class="house-tree-container">
    <ResizableContainer :initial-width="400" height="calc(100vh - 280px)">
      <ProjectTree v-if="mainObj.project_id" :project_id="mainObj.project_id" @node-click="nodeClick" />
    </ResizableContainer>

    <div class="house-tree-list">
      <div class="house-tree-list-header">
        <el-button type="primary" size="mini" @click="$refs.houseInfoComponent.show({},()=>getList())">添加房产</el-button>
        <el-button type="primary" size="mini" @click="setArea()">设置区域</el-button>
        <el-button type="primary" size="mini" @click="$refs.houseTask.show(mainObj.project_id)">房产更新任务</el-button>
      </div>
      <div>
        <HeaderTip>
          房产数：{{pageData.total}}
        </HeaderTip>
        <el-select size="mini" v-model="is_all" @change="pageChange(1)">
          <el-option label="全部" value="1"></el-option>
          <el-option label="亲子房产" value="0"></el-option>
        </el-select>
      </div>
      <el-table
        :data="pageData.data"
        v-loading="loading"
        @selection-change="handleSelectionChange"
        border
        style="width: 100%" height="calc(100vh - 320px)">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column
          fixed
          prop="ancestor_name"
          label="房产名称"
          width="320">
        </el-table-column>
        <el-table-column
          prop="house.charging"
          label="计费面积"
          width="120">
        </el-table-column>
        <el-table-column
          prop="type"
          label="房产类型"
          width="100">
          <template slot-scope="scope">
            <span>{{house_type[scope.row.type]}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="house.room_status_name"
          label="房态"
          width="100">
        </el-table-column>
        <el-table-column
          prop="customer.name"
          label="业主"
          width="100">
        </el-table-column>
        <el-table-column
          fixed="right"
          prop="label"
          label="操作"
          width="200">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="$refs.houseInfoComponent.show(scope.row,()=>getList())">编辑</el-button>
            <el-button type="danger" size="mini" @click="remove(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="house-tree-list-footer">
        <el-pagination
          layout="prev, pager, next"
          :total="pageData.total"
          :current-page="pageData.current_page"
          :page-size="pageData.per_page"
          @current-change="pageChange"
        >
        </el-pagination>
      </div>
    </div>
    <HouseInfoComponent ref="houseInfoComponent" />
    <HouseRelatedInfo ref="houseRelatedInfo" />
    <HouseArea ref="houseArea" />
    <HouseTask ref="houseTask" />
  </div>
</template>

<script>
import ResizableContainer from "../../../Common/ResizableContainer";
import ProjectTree from "../../../Common/ProjectTree";
import Http from "../../../Project/common/Http";
import HeaderTip from "../../../Common/header-tip";
import HouseInfoComponent from "./components/HouseInfoComponent";
import HouseRelatedInfo from "./components/HouseRelatedInfo";
import HouseArea from "./components/HouseArea";
import HouseTask from "./components/HouseTask";

export default {
  name: "HouseTree",
  components: {HouseTask, HouseArea, HouseRelatedInfo, HouseInfoComponent, HeaderTip, ProjectTree, ResizableContainer},
  inject: ['mainObj'],
  data() {
    return {
      pageData: {
        total: 0,
        per_page: 20,
        current_page: 1,
        last_page: 1,
        data: [],
      },
      loading:false,
      treeData:{},
      house_type:{
        0:"空",
        1:"住宅",
        2:"车位",
        3:"储藏室",
        4:"商铺",
      },
      is_all:"1",
    };
  },
  mounted() {
    this.mainObj.project_id&&this.getList();
  },
  methods: {
    nodeClick(data) {
      // console.log(data);
      this.treeData=data;
      this.getList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getList(){
      const that = this;
      if(!that.treeData.erp_pindex_id){
        return;
      }
      that.loading=true;
      Http.get("HouseTree/getHouseList",{
        project_id:that.treeData.erp_pindex_id,
        parent_id:that.treeData.house_id,
        page:that.pageData.current_page,
        is_all:that.is_all,
      },ret=>{
        that.loading=false;
        if(ret.code){
          that.pageData=Object.assign({
            total: 0,
            per_page: 20,
            current_page: 1,
            last_page: 1,
            data: [],
          },ret.data);
        }else {
          that.$message.error(ret.msg);
        }
      })
    },
    pageChange(page=1){
      const that=this;
      that.pageData.current_page=page;
      that.getList();
    },
    remove(row){
      const that=this;
      that.$refs.houseRelatedInfo.show(row,()=>{
        that.getList();
      });

    },
    setArea(){
      const that=this;
      that.$refs.houseArea.show({
        project_id:that.treeData.erp_pindex_id,
        list:that.multipleSelection
      },()=>{
        that.getList();
      });
    },
  },
  watch: {

  },
}
</script>

<style scoped lang="scss">
.el-button--primary,.el-button--success,.el-button--danger,.el-button--warning {
  color: #FFF;
}
.house-tree-container{
  display: flex;
  flex-direction: row;

  .house-tree-list{
    width: calc(100% - 400px);
    height: calc(100vh - 220px);
  }

}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Project/components/house/HouseTree.vue